import { useState, useEffect, useMemo } from "react"
import { db } from "../firebase"
import _ from "lodash"

export default function useSubscribeAllDocs(args) {
  const DEFAULT_LIMIT = 10

  const {
    collection,
    withRef = {},
    filter = [],
    limit = DEFAULT_LIMIT,
    startAfterDoc = null,
  } = args

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [lastVisible, setLastVisible] = useState(null)

  const [error, setError] = useState(null)

  const filterKey = useMemo(() => JSON.stringify(filter), [filter])
  const withRefKey = useMemo(() => JSON.stringify(withRef), [withRef])

  useEffect(() => {
    setLoading(true)
    let query = db
      .collection(collection)
      .orderBy("timestamp_updated", "desc")
      .limit(limit)
    if (!_.isEmpty(filter)) {
      query = query.where(filter[0], filter[1], filter[2])
    }
    if (startAfterDoc) {
      query = query.startAfter(startAfterDoc)
    }
    const unsubscribe = query.onSnapshot(async (querySnapshot) => {
      let docList = []
      if (_.isEmpty(withRef)) {
        querySnapshot.forEach((doc) => {
          docList.push({
            id: doc.id,
            ...doc.data(),
          })
        })
      } else {
        docList = await Promise.all(
          querySnapshot.docs.map(async (doc) => {
            const docData = doc.data()
            const referenceField = docData[withRef.key]
            let referenceData = []
            try {
              const referenceDoc = await referenceField.get()
              referenceData = referenceDoc.data()
              const handleRefValues = () => {
                return _.reduce(
                  withRef.value,
                  (acc, value) => {
                    return {
                      ...acc,
                      [value]: referenceData[value],
                    }
                  },
                  {}
                )
              }
              return {
                id: doc.id,
                ...doc.data(),
                [withRef.key]: handleRefValues(),
              }
            } catch (error) {
              return {
                id: doc.id,
                ...doc.data(),
                [withRef.key]: referenceData,
              }
            }
          })
        )
      }
      setData(docList)
      setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1])
      setLoading(false)
    })

    return () => {
      unsubscribe()
    }
  }, [collection, filterKey, limit, withRefKey, startAfterDoc])

  return [loading, error, data, lastVisible]
}
